export enum DiscountsRouteNames {
  DISCOUNTS_ROOT = 'DiscountsRoot',
  DISCOUNTS_LIST = 'DiscountsRoot/Discounts',
  DISCOUNTS_CREATE = 'DiscountsRoot/Discounts/Create',
  DISCOUNTS_UPDATE = 'DiscountsRoot/Discounts/Update',
  RYST_INCENTIVES_MANAGER = 'DiscountsRoot/Discounts/RystIncentivesManager',
  RYST_LOCATION_USER_MANAGEMENT = 'DiscountsRoot/Discounts/RystIncentivesManager/LocationUser',
  RYST_PROMO_MANAGEMENT = 'DiscountsRoot/Discounts/RystIncentivesManager/Promos',
}
